import { useAppContext } from 'contexts/app-context/hooks'
import { isEmpty } from 'lodash'

export function useDontDistubMessage() {
  const { privacyCenterContent, isAppLoading, isAppError } = useAppContext()

  const content =
    privacyCenterContent?.components?.manageNotifications?.content?.doNotDisturbSection

  const isActive = !!privacyCenterContent?.components?.manageNotifications?.isActive

  const isErrorOrInactive = isAppError || isEmpty(content) || !isActive

  return {
    content,
    isErrorOrInactive,
    isAppLoading,
    isActive,
  }
}
